import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Space,
  Upload,
  message,
} from "antd";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";
import dataService from "../networks/api/service/dataService";
import colors from "../assets/styles/colour";
import uplaodIcon from "../assets/images/uploadicon.png"
const { TextArea } = Input;
const { Option } = Select;

const AppointmentForm = () => {
  const [rolesList, setrolesList] = useState([]);
  const [leaderList, setleaderList] = useState([]);
  const [slots, setslots] = useState([]);
  const [selectedSlots, setselectedSlots] = useState([]);

  // const [roleId, setroleId] = useState("");
  const [selectedRole, setSelectedRole] = useState({
    roleId: "",
    roleName: "",
  });

  const [selectedLeader, setSelectedLeader] = useState({
    id: "",
    name: "",
  });

  const [assemblyId, setAssemblyId] = useState("");
  const [panchayatId, setPanchayatId] = useState("");

  const [boothId, setBoothId] = useState("");
  const [constituencyId, setConstituencyId] = useState("");
  const [constituencyList, setConstituencyList] = useState([]);

  const [assemblyList, setAssemblyList] = useState([]);
  const [panchayatList, setPanchayatList] = useState([]);
  const [boothList, setBoothList] = useState([]);
  const [form] = Form.useForm();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [docResponse, setdocResponse] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [responseId, setResponseId] = useState(null);

  const handleDateChange = async (date) => {
    const cDate = date.format("YYYY-MM-DD");
    if (date) {
      setSelectedDate(cDate);
    }
    setselectedSlots("");
  };
  const handleSlotChange = async (value) => {
    setselectedSlots(value);
  };

  const getSlots = async () => {
    try {
      const res = await dataService.AppointmentSlots(
        selectedLeader.id,
        selectedDate
      );
      console.log("API Response:", res);
      if (res.code === 200) {
        setResponseId(res.data.id);
        setslots(res.data.availableSlots);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (selectedDate && selectedLeader && selectedRole) {
      getSlots();
    }
  }, [selectedDate, selectedLeader, selectedRole]);

  const onFinish = async (values) => {
    console.log(values);
    console.log("Form Values:", {
      ...values,
      assembly: assemblyId,
      panchayat: panchayatId,
      booth: boothId,
      constituency: constituencyId,
      doc: docResponse,
      date: selectedDate,
      slot: selectedSlots,
    });

    const payload = {
      ...values,
      assembly: assemblyId,
      panchayat: panchayatId,
      booth: boothId,
      constituency: constituencyId,
      doc: docResponse,
      date: selectedDate,
      slot: selectedSlots,
      leadersId: selectedLeader.id,
    };

    submitAppointment(payload);
  };

  const submitAppointment = async (payload) => {
    try {
      const res = await dataService.AppointmentBook(
        responseId,
        payload
      );
      if (res.code === 200) {
        message.success("Appointment Booked Successfully");
        form.resetFields();

        setrolesList([]);
        setleaderList([]);
        setselectedSlots([]);
        setSelectedRole({ roleId: "", roleName: "" });
        setSelectedLeader({ id: "", name: "" });
        setAssemblyId("");
        setPanchayatId("");
        setBoothId("");
        setConstituencyId("");
        setAssemblyList([]);
        setPanchayatList([]);
        setBoothList([]);
        setdocResponse(null);
        setSelectedDate(null);
      }
    } catch (e) {
      console.error(e);
      if (e.response) {
        message.error("something went wrong");
      }
    }
  };

  const handleFileUpload = (file) => {
    const allowedFormats = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/msword",
    ];
    if (!allowedFormats.includes(file.type)) {
      message.error(
        "Invalid file format. Only .xlsx, .pdf, and .doc are allowed."
      );
      return Upload.LIST_IGNORE;
    }

    setUploadedFile(file);
    uploadDocument(file);
    return false;
  };

  const uploadDocument = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await dataService.uploadDoc(formData); // Assuming your API accepts FormData
      setdocResponse(res.data);
      message.success("File uploaded successfully");
    } catch (e) {
      message.error("Failed to upload file");
      console.error(e);
    }
  };

  const onRoleSelect = async (value, option) => {
    console.log(value, "s", option);
    setSelectedRole({
      roleId: value,
      roleName: option.children,
    });
    setSelectedLeader({
      id: "",
      name: "",
    });
    setSelectedDate(null);
    try {
      const res = await dataService.AppointmentLeaders(option.children);
      if (res.code === 200) {
        setleaderList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onLeaderSelect = async (value, option) => {
    console.log(value, "s", option);
    setSelectedLeader({
      id: value,
      name: option.children,
    });
    setSelectedDate(null);

    // try {
    //   const res = await dataService.AppointmentLeaders(option.children);
    //   if (res.code === 200) {
    //   }
    // } catch (e) {
    //   console.error(e);
    // }
  };

  const OnConstituencySelect = async (value) => {
    setConstituencyId(value);
    setAssemblyId("");
    setPanchayatId("");
    setBoothId("");
    setAssemblyList([]);
    setBoothList([]);
    setPanchayatList([]);
    try {
      const res = await dataService.getAssemblyFromConstituency(value);
      if (res.code === 200) setAssemblyList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const OnAssemblySelect = async (value) => {
    setAssemblyId(value);
    setPanchayatId("");
    setBoothId("");
    setBoothList([]);
    setPanchayatList([]);
    try {
      const res = await dataService.getPanchayatFromAssembly({
        assembly: value,
      });
      if (res.code === 200) setPanchayatList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const OnPanchayatSelect = async (value) => {
    setPanchayatId(value);
    setBoothId("");
    setBoothList([]);
    try {
      const res = await dataService.GetBooth({ panchayat: value });
      if (res.code === 200) setBoothList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const OnBoothSelect = (value) => setBoothId(value);

  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) setConstituencyList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const getRoles = async () => {
    try {
      const res = await dataService.AppointmentRoles();
      if (res.code === 200) {
        setrolesList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getConstituency();
    getRoles();
  }, []);

  return (
    <div style={{ background: "white", minHeight: "100vh" }}>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        //   onFinishFailed={onFinishFailed}
        style={{
          maxWidth: 800,
          margin: "0 auto",
          padding: "2rem",
          backgroundColor: "#f7f7f7",
          borderRadius: "8px",
        }}
      >
        <h2 style={{ textAlign: "center", color: colors.sidebarText }}>
          Appointment Form
        </h2>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Name"
              name="name"
              // rules={[{ required: true, message: "Please enter your name" }]}
            >
              <Input placeholder="Enter your name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please enter your email" }]}
            >
              <Input placeholder="Enter your email" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Mobile Number"
              name="mobileNo"
              // rules={[{ required: true, message: "Please enter your mobile number" }]}
            >
              <Input placeholder="Enter your mobile number" maxLength={10} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Address"
              name="address"
              // rules={[{ required: true, message: "Please enter your address" }]}
            >
              <Input placeholder="Enter your address" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="Location Details" required>
          <Space wrap>
            <Select
              value={constituencyId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Constituency"
              onChange={OnConstituencySelect}
              style={{ border: "1.8px solid rgb(202, 142, 70)", borderRadius: 7 }}
            >
              <Option key={827272} value="" disabled>
                Select Parliament
              </Option>
              {constituencyList.map((item) => (
                <Option key={item._id} value={item._id}>
                  {item.constituencyName}
                </Option>
              ))}
            </Select>

            <Select
              value={assemblyId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Assembly"
              onChange={OnAssemblySelect}
              disabled={!constituencyId}
              style={{ border: "1.8px solid rgb(202, 142, 70)", borderRadius: 7 }}
            >
              <Option key={827272} value="" disabled>
                Select Assembly
              </Option>
              {assemblyList.map((item) => (
                <Option key={item._id} value={item._id}>
                  {item.assemblyName}
                </Option>
              ))}
            </Select>

            <Select
              value={panchayatId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Panchayat"
              onChange={OnPanchayatSelect}
              disabled={!assemblyId}
              style={{ border: "1.8px solid rgb(202, 142, 70)", borderRadius: 7 }}
            >
              <Option key={827272} value="" disabled>
                Select Panchayat
              </Option>
              {panchayatList.map((item) => (
                <Option key={item._id} value={item._id}>
                  {item.panchayatName}
                </Option>
              ))}
            </Select>

            <Select
              value={boothId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Booth"
              onChange={OnBoothSelect}
              disabled={!panchayatId}
              style={{ border: "1.8px solid rgb(202, 142, 70)", borderRadius: 7 }}
            >
              <Option key={827272} value="" disabled>
                Select Booth
              </Option>
              {boothList.map((item) => (
                <Option key={item._id} value={item._id}>
                  {item.boothNumber}
                </Option>
              ))}
            </Select>
          </Space>
        </Form.Item>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label="Select Role"
              required
              // rules={[{ required: true, message: "Please select a role" }]}
            >
              <Select
                value={selectedRole.roleId}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const children = option?.children;
                  return String(children)
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
                placeholder="Select Role"
                onChange={onRoleSelect}
                style={{ border: "1.8px solid rgb(202, 142, 70)", borderRadius: 7 }}
              >
                <Option key={827272} value="" disabled>
                  Select Role
                </Option>
                {rolesList?.map((item) => (
                  <Option key={item._id} value={item._id}>
                    {item.roleName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              required
              label="Select Leader"
              rules={[{ required: true, message: "Please select a Name" }]}
            >
              <Select
                value={selectedLeader.id}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const children = option?.children;
                  return String(children)
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
                placeholder="Select Leader"
                onChange={onLeaderSelect}
                style={{ border: "1.8px solid rgb(202, 142, 70)", borderRadius: 7 }}
              >
                <Option key={827272} value="" disabled>
                  Select Leader
                </Option>
                {leaderList?.map((item) => (
                  <Option key={item._id} value={item._id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              required
              // name="date"
              label="Date"
              rules={[{ required: true, message: "Please select a date!" }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                value={selectedDate ? moment(selectedDate) : null}
                onChange={handleDateChange}
                
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          {/* Slot */}
          {selectedDate && (
            <Col span={12}>
              <Form.Item
                // name="slot"
                label="Slot"
                rules={[
                  { required: true, message: "Please select a time slot!" },
                ]}
              >
                <Select
                  value={selectedSlots}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    const children = option?.children;
                    return String(children)
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  placeholder="Select Slots"
                  onChange={handleSlotChange}
                  style={{ border: "1.8px solid rgb(202, 142, 70)", borderRadius: 7 }}
                >
                  <Option key={827272} value="" disabled>
                    Select Slots
                  </Option>
                  {slots?.map((item) => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>

        <Form.Item
          label="Reason for Appointment"
          name="reason"
          rules={[
            {
              required: true,
              message: "Please provide a reason for the appointment",
            },
          ]}
        >
          <TextArea rows={4} placeholder="Describe the issue you are facing" />
        </Form.Item>

        <Form layout="vertical">
          <Form.Item label="Upload Document">
            <Upload
              beforeUpload={handleFileUpload}
              showUploadList={false} // Prevents showing the default upload list
            >
              <Button style={{border: "1.8px solid rgb(202, 142, 70)"}} icon={<img src= {uplaodIcon}alt="upload" style={{ width: 16, height: 16,  }} />}>Upload File</Button>
            </Upload>
            {uploadedFile && (
              <p>
                Uploaded file: <strong>{uploadedFile.name}</strong>
              </p>
            )}
          </Form.Item>
        </Form>

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: "100%" , backgroundColor: colors.button }}>
            Submit Appointment
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AppointmentForm;
